const ListItemMixin = {
  name: 'mediaList',
  props: ['side'],
  created () {
  },
  data () {
    return {
      errors: {},
      editedPlayListItem: undefined,
      editPlayListItemVisible: false,
      editMediumVisible: false,
      editedMedium: undefined,
      videoSource: '',
      imageSource: '',
      videoPlayVisible: false,
      imagePreviewVisible: false,
      moment: this.$moment,
      multipleSelection: []
    }
  },
  watch: {
  },
  methods: {
    getPreviewPath (file) {
      if (!file || !file.originalsha256 || !file.currentsha256) return
      return file.filename
    },
    getVideoPath (file) {
      if (!file || !file.currentsha256 || !file.currentsha256) return
      return file.filename
    },
    getImagePath (file) {
      if (!file || !file.currentsha256 || !file.currentsha256) return
      return file.filename
    },
    playVideo (file) {
      if (!file || !file.currentsha256) return
      this.videoSource = file.filename
      this.videoPlayVisible = true
    },
    showImage (file) {
      if (!file || !file.currentsha256) return
      this.imageSource = file.filename
      this.imagePreviewVisible = true
    },
    closeVideo () {
      this.videoPlayVisible = false
      this.videoSource = ''
    },
    closeImage () {
      this.imagePreviewVisible = false
      this.imageSource = ''
    },
    closePlayMedium () {
      this.playedMedium = undefined
      this.playMediumVisible = false
    },
    playMedium (medium) {
      this.playedMedium = medium
      this.playMediumVisible = true
    },
    playPlayList (previewFile) {
      return console.log('TODO. Play PlayList', previewFile)
    },
    editMedium (medium) {
      this.editMediumVisible = true
      this.editedMedium = medium
    },
    loadEditMediumInMediaEditor (medium) {
      this.$emit('loadEditMediumInMediaEditor', medium)
    },
    isSelectedRight (medium) {
      if (!medium) return false
      if (this.$store.state.Medium.media_selected_right.length === 0 || !medium) return false
      return this.$store.state.Medium.media_selected_right.findIndex((ms) => {
        if (!ms) return false
        return ms.id === medium.id
      }) > -1
    },
    isSelectedLeft (medium) {
      if (!medium) return false
      if (this.$store.state.Medium.media_selected_left.length === 0 || !medium) return false
      return this.$store.state.Medium.media_selected_left.findIndex((ms) => {
        if (!ms) return false
        return ms.id === medium.id
      }) > -1
    }
  },
  computed: {
  }
}

export default ListItemMixin



// WEBPACK FOOTER //
// ./src/components/Medium/ListItem.mixin.js